import { render, staticRenderFns } from "./CallCard.vue?vue&type=template&id=21cbcc34&scoped=true&"
import script from "./CallCard.vue?vue&type=script&lang=js&"
export * from "./CallCard.vue?vue&type=script&lang=js&"
import style0 from "./CallCard.vue?vue&type=style&index=0&id=21cbcc34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cbcc34",
  null
  
)

export default component.exports